<template>
  <Head :title="__('vip-category.index.meta_title')">
    <meta
      name="description"
      :content="__('vip-category.index.meta_description')"
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.categories.index')"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section class="py-12 md:py-20 relative overflow-hidden">
    <img
      src="/frontend/assets/mobile-hero-swirl.svg"
      class="absolute top-0 left-0 lg:hidden"
    >
    <img
      src="/frontend/assets/desktop-hero-swirl.svg"
      class="absolute top-0 left-0 hidden lg:block"
    >

    <div class="container">
      <div class="text-center px-8">
        <h1 class="text-5xl font-bold lg:text-7xl">
          {{ __('vip-category.index.title') }}
        </h1>
      </div>
    </div>
  </section>

  <section class="container pb-8">
    <div class="grid grid-cols-2 lg:grid-cols-6 gap-4">
      <template
        v-for="category in vipCategories"
        :key="category.slug"
      >
        <Link
          type="button"
          class="w-full border-2 border-black block content-center text-center text-sm font-bold py-3 rounded-lg md:w-auto md:px-8 md:mt-0 hover:bg-gray-100 bg-white"
          :href="localeRoute('frontend.categories.slug', [category.slug])"
        >
          {{ category.name }}
        </Link>
      </template>
    </div>
  </section>
</template>

<script>
export default {
  components: {},

  props: {
    vipCategories: {
      type: Object,
      required: true,
    },
  },
};
</script>
